import { useState } from "react";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleContactUsSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://rzjt6kcb08.execute-api.us-east-2.amazonaws.com/prod/api/contacts",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name || "",
            email: formData.email || "",
            phone: formData.phone || "",
            message: formData.message || "",
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      } else {
        // Optionally reset the form or show a success message
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
        alert("Your contact details have been sent successfully!");
      }
    } catch (error) {
      console.error("Error sending contact details: ", error);
    }
  };

  return (
    <>
      <div id="contact-us" className="container-fluid bg-light min-vh-100 py-5">
        <div className="container">
          {/* Header Section */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8">
              <div
                className="text-center p-5 rounded-4 text-white fw-bold"
                style={{
                  backgroundColor: "#2d5128",
                  fontSize: "2.5rem",
                  lineHeight: "1.2",
                }}
              >
                READY TO TRANSFORM YOUR SPACE?
                <br />
                LET'S TALK
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="row">
            {/* Contact Info */}
            <div className="col-lg-6 mb-5 mb-lg-0">
              <h2
                className="mb-4 text-secondary fw-normal"
                style={{ fontSize: "1.8rem" }}
              >
                Contact Us
              </h2>

              <div className="mb-4">
                <div className="d-flex align-items-start">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                    style={{
                      width: "50px",
                      height: "50px",
                      backgroundColor: "#2d5128",
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      fill="white"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                    </svg>
                  </div>
                  <div className="text-secondary">
                    <div>5858 Dixie Road,</div>
                    <div>Mississauga L4W 1E7</div>
                    <div>Ontario, Canada</div>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <div className="d-flex align-items-center">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{
                      width: "50px",
                      height: "50px",
                      backgroundColor: "#2d5128",
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      fill="white"
                      viewBox="0 0 24 24"
                    >
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                    </svg>
                  </div>
                  <div className="text-secondary">
                    +1 (647) 819-0124 , +1 (514) 992-9216
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <div className="d-flex align-items-start">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                    style={{
                      width: "50px",
                      height: "50px",
                      backgroundColor: "#2d5128",
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      fill="white"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                    </svg>
                  </div>
                  <div className="text-secondary">
                    <div>info@broadwaybuildingsolutions.com</div>
                    <a href="https://www.broadwaybuildingsolutions.com">
                      www.broadwaybuildingsolutions.com
                    </a>
                  </div>
                </div>
              </div>

              <div>
                {/* <div className="d-flex align-items-center">
                  <div 
                    className="rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ 
                      width: '50px', 
                      height: '50px', 
                      backgroundColor: '#333' 
                    }}
                  >
                    <svg width="20" height="20" fill="white" viewBox="0 0 24 24">
                      <path d="M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"/>
                    </svg>
                  </div>
                  <div className="text-secondary"> +1 (647) 819-0124 , +1 (514) 992-9216</div>
                </div> */}
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-6">
              <div
                className="p-4 rounded-4 position-relative"
                style={{
                  backgroundColor: "#2d5128",
                  border: "3px solid #2d5128",
                }}
              >
                <div onSubmit={handleContactUsSubmit}>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label text-light">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      style={{
                        backgroundColor: "white",
                        border: "none",
                        padding: "12px",
                      }}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label text-light">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      style={{
                        backgroundColor: "white",
                        border: "none",
                        padding: "12px",
                      }}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label text-light">
                      Phone
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      style={{
                        backgroundColor: "white",
                        border: "none",
                        padding: "12px",
                      }}
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="message" className="form-label text-light">
                      Your message (optional)
                    </label>
                    <textarea
                      className="form-control"
                      id="message"
                      name="message"
                      rows="4"
                      value={formData.message}
                      onChange={handleChange}
                      style={{
                        backgroundColor: "white",
                        border: "none",
                        padding: "12px",
                        resize: "vertical",
                      }}
                    ></textarea>
                  </div>

                  <button
                    type="button"
                    onClick={handleContactUsSubmit}
                    className="btn text-dark fw-semibold px-4 py-2"
                    style={{
                      backgroundColor: "white",
                      border: "none",
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
